module.exports = __webpack_public_path__ + "static/img/1-2.eced760.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/1-2.png
// module id = i30t
// module chunks = 0